module.exports = __webpack_public_path__ + "static/media/nexttellogo-512.83dfe70e.png";